import axios from '@/config/httpConfig'

//富文本图片上传
export function fileCKUploadImg(data) {
  return axios.post('/file/CKUploadImg', data)
}
